/**
 * Account: Entity Switcher Routes.
 */
export const entitySwitcher = {
  entitySwitcher: '/account/entity-switcher',
}
